@use '../../../../../styles/Colors.scss' as Colors;
@use '../../../../../styles/Constants.scss' as Constants;

.unit-price {
	background-color: Colors.$col-white;
}

.error-row {
	background-color: Colors.$col-redBackground !important;
}

.color-input-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	background-color: Colors.$col-white;
	width: 100%;
	height: max-content;
}

.index-column {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	background-color: Colors.$col-white;
	width: 100%;
	height: 100%;
}

.sort-groups-modal__help {
	margin-bottom: Constants.$val-spacing-m;
	font-size: Constants.$val-fontSizeSmall;
	line-height: Constants.$val-lineHeightSmall;
	color: Colors.$col-greyFontLight;
}

.sort-groups-modal__list {
	padding: Constants.$val-spacing-xs 0;
}

.sort-groups-modal__row {
	display: grid;
	grid-template-columns:
		Constants.$val-icon24
		Constants.$val-icon24
		Constants.$val-spacing-s
		1fr;
	align-items: center;
	gap: Constants.$val-spacing-s;
	padding: Constants.$val-spacing-xs 0;
}

.sort-groups-modal__row--dragging {
	background: Colors.$col-greyLight;
}

.sort-groups-modal__row-index {
	text-align: right;
	font-size: Constants.$val-fontSizeSmall;
	color: Colors.$col-greyFontLight;
}

.sort-groups-modal__drag-handle {
	width: Constants.$val-icon24;
	height: Constants.$val-inputHeight;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: grab;	color: Colors.$col-greyFontLight;
}

.sort-groups-modal__drag-handle:active {
	cursor: grabbing;
}

.sort-groups-modal__color {
	width: Constants.$val-colorSquareSizeS;
	height: Constants.$val-colorSquareSizeS;
	border-radius: Constants.$val-borderRadius;
}

.sort-groups-modal__label {
	height: Constants.$val-inputHeight;
	display: flex;
	align-items: center;
	padding: 0 Constants.$val-spacing-s;
	border: 1px solid Colors.$col-greyMid;
	border-radius: Constants.$val-borderRadius-l;
	background: Colors.$col-white;
	font-size: Constants.$val-fontSizeRegular;
}

.group {
	display: flex;
	flex-direction: row;
	padding: Constants.$val-spacing-xs;
	width: 500px;
}

.group-name {
	display: flex;
	flex-direction: row;
	gap: Constants.$val-spacing-s;
	width: 100%;
	padding: Constants.$val-spacing-xs;
	border: 1px solid Colors.$col-greyMid;
}

.group-index {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	padding: Constants.$val-spacing-xs;
	color: Colors.$col-greyFontLight;
}

.group-drag-handle {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	padding: Constants.$val-spacing-xs;
}

.group-option {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	padding: Constants.$val-spacing-xs;
	gap: Constants.$val-spacing-xs;
}

.group-name-header {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	padding-left: Constants.$val-spacing-s;
}

@mixin readonly-cell-content {
	padding: Constants.$val-spacing-xs Constants.$val-spacing-s;
	line-height: 1.5;
	color: Colors.$col-blackDark;
	flex: 1;

	display: flex;
	align-items: center;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	background-color: white;
	width: 100%;
	height: 100%;
}

.readonly-cell {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: Constants.$val-spacing-xs;
	padding: Constants.$val-spacing-xs;
	background-color: white;
	width: 100%;
	height: 100%;

	&--text,
	&--numeric,
	&--quantity,
	&--dollar {
		@include readonly-cell-content;
	}

	&--numeric {
		text-align: start;
	}

	&--quantity,
	&--dollar {
		text-align: end;
		justify-content: flex-end;
	}

	&--archived {
		color: Colors.$col-design-grey400 !important;
		background-color: Colors.$col-greyBackgorund2 !important;
		width: 100%;
	}

	&--clickable {
		cursor: pointer;
	}
}

.edit-cell-icon {
	font-size: Constants.$val-fontSizeBig;
	cursor: pointer;
	color: Colors.$col-design-blue500;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	padding-left: Constants.$val-spacing-s;
}

.info-icon {
	font-size: Constants.$val-fontSizeBig;
	cursor: pointer;
	color: Colors.$col-design-blue500;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	padding-left: Constants.$val-spacing-s;
}

.bold {
	font-weight: bold;
}

.modal-intro-text {
	font-weight: bold;
	font-size: Constants.$val-fontSizeBig;
	line-height: Constants.$val-lineHeightBig;
	padding-bottom: Constants.$val-spacing-m;
}

.modal-billing-code-container {
	padding-bottom: Constants.$val-spacing-m;
}

.billing-code-description {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: Constants.$val-spacing-xs;
}

.radio-label {
	display: flex;
	flex-direction: row;
	gap: Constants.$val-spacing-xs;
	cursor: pointer;
	justify-content: flex-start;
	align-items: center;
	padding-bottom: Constants.$val-spacing-m;

	&__input {
		cursor: pointer;
		margin-bottom: Constants.$val-spacing-m !important;
		padding: Constants.$val-spacing-m !important;

		&::before {
			cursor: pointer;
			left: Constants.$val-spacing-l !important;
		}
	}
}

.archive-modal-question {
	padding-bottom: Constants.$val-spacing-m;
}

.archive-modal-warning-text {
	padding-top: Constants.$val-spacing-s;
}
